import { DatePicker, Form } from "antd";
import type { Dayjs } from "dayjs";
import React, { CSSProperties } from "react";
import { getRequiredErrorMessage, getSelectPlaceholderMessage } from "../../../libs/form";
import { DATE_FORMATS, formatDateByType } from "../../../libs/utils";

export const CLEARING_DATE_FIELD_NAME = "clearing date";

export const getClearingDateError = (value: Dayjs | null): string | undefined => {
  if (!value || !formatDateByType(value, "api")) {
    return getRequiredErrorMessage(CLEARING_DATE_FIELD_NAME);
  }
  return undefined;
};

export const isClearingDateValid = (value: Dayjs | null): boolean => !getClearingDateError(value);

type ClearingDatePickerProps = {
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  showValidation?: boolean;
  width?: number;
  style?: CSSProperties;
};

const labelStyle: CSSProperties = {
  display: "block",
  marginBottom: 8,
  fontSize: 14,
  lineHeight: 1.5715,
  color: "rgba(0, 0, 0, 0.88)",
};

export const ClearingDatePicker = (props: ClearingDatePickerProps) => {
  const { value, onChange, showValidation = false, width = 180, style } = props;
  const error = showValidation ? getClearingDateError(value) : undefined;

  return (
    <div style={{ width, height: 86 }}>
      <label style={labelStyle}>
        Clearing Date <span style={{ color: "#ff4d4f", marginInlineStart: 4 }}>*</span>
      </label>
      <Form.Item validateStatus={error ? "error" : undefined} help={error} style={{ marginBottom: 0 }}>
        <DatePicker
          style={{ width: "100%", borderRadius: 8, ...style }}
          format={DATE_FORMATS.display}
          placeholder={getSelectPlaceholderMessage(CLEARING_DATE_FIELD_NAME)}
          value={value}
          onChange={onChange}
          status={error ? "error" : undefined}
        />
      </Form.Item>
    </div>
  );
};
